// @flow
import React from 'react';
import Flex from '@waglabs/flex';
import Text from '@waglabs/text';
import Link from '@waglabs/link';

type Props = {
  section: {
    label: string,
    links: {
      label: string,
      path: string,
      target?: string,
    }[],
  },
};

export const FooterLinksGroup = ({
  section,
}: Props) => (
  <Flex
    flexDirection="column"
    mr={[0, 3]}
  >
    <Text
      color="wagGreen"
      fontFamily="body"
      fontSize={[2, 2, 2, 3]}
      mb={2}
    >
      {section.label}
    </Text>
    {section.links.map(link => (
      <Link
        key={link.label}
        width={[120, 130, 1]}
        maxWidth={[120, 130, 130, 220]}
        href={link.path}
        mb={1}
        color="medGray"
        fontFamily="body"
        fontSize={[14, 14, 14, 2]}
        target={link.target}
      >
        {link.label}
      </Link>
    ))}
  </Flex>
);
